import React from 'react'

import { Heading4, Strong, Body3, Space } from '@gousto-internal/citrus-react'
import Immutable from 'immutable'
import PropTypes from 'prop-types'

import menu from 'config/menu'

const replaceGluten = (allergens) =>
  allergens.map((a) => (a === 'gluten' ? 'cereals containing gluten' : a))

export const allergenNamesInParentheses = (allergens) => {
  const allergenString = replaceGluten(allergens).join(', ')
  const allergenText = `(${allergenString})`

  return allergenText
}

const Allergens = ({ allergens }) => (
  <>
    <Heading4>Allergens</Heading4>
    <Space size={4} />
    {allergens.size > 0 ? (
      <Body3 data-testing="allergen">
        For allergens, see ingredients in
        <Strong> BOLD. </Strong>
        <Strong>{allergenNamesInParentheses(allergens)}</Strong>
      </Body3>
    ) : null}
    <Body3>{menu.legal}</Body3>
  </>
)

Allergens.propTypes = {
  allergens: PropTypes.instanceOf(Immutable.List).isRequired,
}

export { Allergens }
